import { createContext } from 'react';
import { IAppToolsContext } from '../types/appTools';

const AppToolsContext = createContext<IAppToolsContext | null>(null);

export default AppToolsContext;
